import { ThemeSelector } from "@ruter-as/web-components-and-tools";
import type React from "react";
import { Route, Routes } from "react-router";
import "./App.scss";

import { getTenant } from "../env";
import OrderForm from "./order-form/OrderForm";
import CancelSubscriptionPage from "./subscription/CancelSubscription.page";
import CancelTicketPage from "./subscription/CancelTicket.page";
import EditZonePage from "./subscription/EditZone.page";
import SubscriptionPage from "./subscription/Subscription.page";
import CompanyTicketInfoPage from "./wrapper/CompanyTicketInfoPage";
import SubscriptionInfoPage from "./wrapper/SubscriptionInfo";
import Wrapper from "./wrapper/Wrapper";

const App: React.FC = () => {
	return (
		<Wrapper>
			<ThemeSelector theme={getTenant()} />
			<Routes>
				<Route path="/abonnement" element={<SubscriptionPage />} />
				<Route path="/abonnement/ny" element={<OrderForm />} />
				<Route
					path="/info/bedriftsbillett"
					element={<CompanyTicketInfoPage />}
				/>
				<Route path="/info/abonnement" element={<SubscriptionInfoPage />} />
				<Route path="/abonnement/:id/avslutt" element={<CancelTicketPage />} />
				<Route
					path="/abonnement/:id/avsluttabonnement"
					element={<CancelSubscriptionPage />}
				/>
				<Route path="/abonnement/:id/endre-sone" element={<EditZonePage />} />
			</Routes>
		</Wrapper>
	);
};

export default App;
